import { render, staticRenderFns } from "./CommunitiesComp.vue?vue&type=template&id=83b3f030&scoped=true"
import script from "./CommunitiesComp.vue?vue&type=script&lang=js"
export * from "./CommunitiesComp.vue?vue&type=script&lang=js"
import style0 from "./CommunitiesComp.vue?vue&type=style&index=0&id=83b3f030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b3f030",
  null
  
)

/* custom blocks */
import block0 from "./CommunitiesComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports